
import { Flex, Box, Text } from "@chakra-ui/react";

import PopoverIcon from "modules/experiments/AhPlusPricingPlans/PopoverIcon";
import { Check, InfoOutline } from "@airhelp/icons";

import type { PlanBoxItemProps } from "./PlanBoxItem.d";

const PlanBoxItem = ({ items }: PlanBoxItemProps) => {
  const { popoverText, text, textExtend, highlighted, markIconHidden } = items;

  const itemColor = highlighted ? "success.600" : "greyscale.600";
  const itemFontWeight = highlighted || markIconHidden ? "medium" : "normal";
  const iconColor = "green.500";

  const styledCheckIcon = <Check ml={-1.5} mr={2} boxSize={6} color={iconColor} />;

  const markIcon = !markIconHidden && styledCheckIcon;

  return (
    <Flex mb={4} mx={0} alignItems="flex-start" color="primary.900">
      {markIcon}
      <Box color={itemColor} fontWeight={itemFontWeight} fontSize="md">
        {text}
        {popoverText && (
          <PopoverIcon
            icon={<InfoOutline color="greyscale.600" boxSize={4} mb={1} />}
            content={popoverText}
          />
        )}
        <Text
          color={itemColor}
          fontWeight={itemFontWeight}
          fontSize="md"
          dangerouslySetInnerHTML={{ __html: textExtend }}
        />
      </Box>
    </Flex>
  );
};

export default PlanBoxItem;
